import React from 'react';
import { Outlet } from 'react-router-dom';
import TopNav from '../TopNav/TopNav';
import PanelShopNav from './PanelShopNav';

const PanelShopContainer = () => (
  <>
    <TopNav />
    <PanelShopNav />
    <main className="container-fluid mt-4" aria-label="Panel Shop">
      <Outlet />
    </main>
  </>
);

export default PanelShopContainer;
